export default {

    BATHTUB: {
        stepOne: {
            menu: {
                title: 'Massanfertigung',
                body:  {
                    len: '2',
                    1:   'Grundgrösse:',
                    2:   'Effektive Masse:',
                },
            },
            form: {
                title:  'Effektive Masse',
                width:  'BREITE (CM)',
                length: 'LÄNGE (CM)',
                to:     'bis',
            },

        },
        stepTwo: {
            menu: {
                title: 'Zargen',
                body:  {
                    len:   '2',
                    1:     'Zargencode',
                    2:     'Teilzarge',
                    back:  'hinten',
                    front: 'vorne',
                    left:  'links',
                    right: 'rechts',
                },
            },
            form: {
                title:    'Zargencode:',
                checkbox: 'Teilzarge',
                left:     'Links',
                right:    'Rechts',
                back:     'Hinten',
                front:    'Vorne',
            },
            summary: {
                Z23: {
                    '1':  "Zarge hinten",
                    '02': "Teilzarge hinten links",
                    '03': "Teilzarge hinten rechts"
                },
                Z45: {
                    '1':  "Zarge rechts",
                    '04': "Teilzarge rechts hinten",
                    '05': "Teilzarge rechts vorne"
                },
                Z67: {
                    '1':  "Zarge vorne",
                    '06': "Teilzarge vorne rechts",
                    '07': "Teilzarge vorne links"
                },
                Z81: {
                    '1':  "Zarge links",
                    '01': "Teilzarge links hinten",
                    '08': "Teilzarge links vorne"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Eckausführungen',
                title2: 'Eckausführung',
                body:  {
                    len: '1',
                    1:   'Ecke(n) definiert',
                    EA12: 'Hinten links',
                    EA34: 'Hinten rechts',
                    EA78: 'Vorne links',
                    EA56: 'Vorne rechts',
                },
            },
            form: {
                back_left:   'Hinten Links',
                back_right:  'Hinten Rechts',
                front_left:  'Vorne Links',
                front_right: 'Vorne Rechts',
            },

        },
        stepFour: {
            menu: {
                title: 'Lochbohrungen für Armaturen',
                body:  {
                    len: '1',
                    1:   'Loch für Einlochmischer',
                    2:   'vorne rechts',
                    L1:  'Einlochmischer',
                    L2:  'Rundloch in Badewannenrand',
                    AT:  'Lochbohrungen für Armatur nach Mass',
                },
            },
            form: {
                armatur_type:          'Art der Armatur',
                position:              'Position',
                checkbox:              'Teilschürze',
                L1:                    'Einlochmischer',
                L2:                    'Rundloch in Badewannenrand',
                AT:                    'Lochbohrungen für Armatur nach Mass',
                L2M:                   'mm',
                armatur:               'ARMATUR',
                armatur_placeholder:   'Hersteller und Modellbezeichnung',
                anmerkung:             'ANMERKUNG',
                anmerkung_placeholder: 'Beispieltext',
                drawing_upload:        'ZEICHNUNG HOCHLADEN',
                drawing_necessary:     'Zeichnung notwendig',
            },

        },
        stepFive: {
            menu: {
                title: 'Garnituren',
                body:  {
                    len:  '1',
                    1:    'Vorhanden',
                    SPV:  'SPLASH',
                    ALGV: 'Ab-/',
                },
            },
            form: {
                title:      'OBERFLÄCHENVEREDELUNG',
                text_field: {
                    placeholder: 'Position bei Sonderwunsch',
                },
                SPV:     'Schmidlin SPLASH Einlaufgarnitur',
                ALGV:    'Ab-/Überlaufgarnitur',
                options: [
                    'Farbname',
                ],
                checkbox: {
                    label1: 'ANTIGLISS PRO',
                    label2: 'GLASUR PLUS',
                },
            },

        },
        stepSix: {
            menu: {
                title: 'Griffe',
                body:  {
                    len: '1',
                    1:   'Vorhanden',
                    GR:  'Griff',
                },
            },
            form: {
                GR:         'Mit Griff(en)',
                text_field: {
                    placeholder: 'Textfeld für Sonderwunsch',
                },
            },

        },
        stepSeven: {
            menu: {
                title: 'Whirlsysteme',
                body:  {
                    len:         '2',
                    whirlsystem: 'Whirlsystem',
                    TA:          'Temperaturanzeige',
                    WM:          'Wassermelder',
                    FL2:         'Farblicht-Therapie',
                    SW2:         'Unterwasser-Scheinwerfer',
                    ALG:         'Ab-/Überlaufgarnitur'
                },
            },
            form: {
                armatur:  'Armatur',
                option: 'OPTIONEN',
                TA:     'Temperaturanzeige',
                WM:     'Wassermelder',
                FL2:    'Farblicht-Therapie',
                SW2:    'Unterwasser-Scheinwerfer',
                system: 'Mit Whirlsystem',
            },

        },
        stepEight: {
            menu: {
                title: 'Soundsystem',
                body:  {
                    len:         '1',
                    1:           'Soundsystem',
                    soundsystem: 'Soundsystem',
                },
            },
            form: {
                system: 'Mit Soundsytem',
            },
        },

        stepNine: {
            menu: {
                title: 'Oberfläche',
                title2: 'Farbe',
                body:  {
                    len:       '2',
                    1:         'weiss matt',
                    2:         'ANTIGLISS PRO, GLASUR PLUS',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'GLASUR PLUS',
                },
            },
            form: {
                ober:           'OBERFLÄCHENVEREDELUNG',
                glazePlus:      'GLASUR PLUS',
                antiglissPro:   'ANTIGLISS PRO',
                txtPlaceholder: 'Textfeld für Sonderwunsch',
                colorName:      'Farbname',
                options:        [
                    'Farbname',
                ],
            },

        },


    },
    DWDF: {
        stepOne: {
            menu: {
                title: 'Massanfertigung',
                body:  {
                    len: '2',
                    1:   'Grundgrösse:',
                    2:   'Effektive Masse:',
                },
            },
            form: {
                title:  'Grundgrösse',
                width:  'BREITE (CM)',
                length: 'LÄNGE (CM)',
                to:     'bis',
            },

        },
        stepTwo: {
            menu: {
                title: 'Zargen',
                body:  {
                    len:   '2',
                    1:     'Zargencode',
                    2:     'Teilzarge',
                    back:  'hinten',
                    front: 'vorne',
                    left:  'links',
                    right: 'rechts',
                },
            },
            form: {
                title:    'Zargencode:',
                checkbox: 'Teilzarge',
                left:     'Links',
                right:    'Rechts',
                back:     'Hinten',
                front:    'Vorne',
            },
            summary: {
                Z23: {
                    '1':  "Zarge hinten",
                    '02': "Teilzarge hinten links",
                    '03': "Teilzarge hinten rechts"
                },
                Z45: {
                    '1':  "Zarge rechts",
                    '04': "Teilzarge rechts hinten",
                    '05': "Teilzarge rechts vorne"
                },
                Z67: {
                    '1':  "Zarge vorne",
                    '06': "Teilzarge vorne rechts",
                    '07': "Teilzarge vorne links"
                },
                Z81: {
                    '1':  "Zarge links",
                    '01': "Teilzarge links hinten",
                    '08': "Teilzarge links vorne"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Eckausführungen',
                title2: 'Eckausführung',
                body:  {
                    len: '1',
                    1:   'Ecke(n) definiert',
                    EA12: 'Hinten links',
                    EA34: 'Hinten rechts',
                    EA78: 'Vorne links',
                    EA56: 'Vorne rechts',
                },
            },
            form: {
                back_left:   'Hinten Links',
                back_right:  'Hinten Rechts',
                front_left:  'Vorne Links',
                front_right: 'Vorne Rechts',
            },

        },
        stepFour: {
            menu: {
                title: 'Schürzen',
                sheight:  'Schürzenhöhe:',
                body:  {
                    len:   '1',
                    1:     'Loch für Einlochmischer vorne rechts',
                    back:  'hinten',
                    front: 'vorne',
                    left:  'links',
                    right: 'rechts',
                },
            },
            form: {
                title:    'Schürzencode:',
                checkbox: 'Teilschürze',
                sheight:  'Schürzenhöhe (cm):',
                left:     'Links',
                right:    'Rechts',
                back:     'Hinten',
                front:    'Vorne',
            },
            summary: {
                S23: {
                    '1':  "Schürze hinten",
                    '02': "Teilschürze hinten links",
                    '03': "Teilschürze hinten rechts"
                },
                S45: {
                    '1':  "Schürze rechts",
                    '04': "Teilschürze rechts hinten",
                    '05': "Teilschürze rechts vorne"
                },
                S67: {
                    '1':  "Schürze vorne",
                    '06': "Teilschürze vorne rechts",
                    '07': "Teilschürze vorne links"
                },
                S81: {
                    '1':  "Schürze links",
                    '01': "Teilschürze links hinten",
                    '08': "Teilschürze links vorne"
                }
            }
        },
        stepFive: {
            menu: {
                title: 'Oberfläche',
                title2: 'Farbe',
                body:  {
                    len:       '2',
                    1:         'weiss matt',
                    2:         'ANTIGLISS PRO, GLASUR PLUS',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'GLASUR PLUS',
                    aquagrip:  'AQUAGRIP',
                    MISSING_GP: 'ANTIGLISS PRO',
                    OV:        'GLASUR PLUS',
                    MISSING_AG: 'AQUAGRIP',
                },
            },
            form: {
                ober:           'OBERFLÄCHENVEREDELUNG',
                glazePlus:      'GLASUR PLUS',
                antiglissPro:   'ANTIGLISS PRO',
                aquagrip:       'AQUAGRIP',
                txtPlaceholder: 'Textfeld für Sonderwunsch',
                colorName:      'Farbname',
                options:        [
                    'Farbname',
                ],
            },
        },

    },
    WT: {
        stepOne: {
            menu: {
                title: 'Massanfertigung',
                body:  {
                    len: '2',
                    1:   'Grundmasse:',
                    2:   'Effektive Masse:',
                },
                left:  'Achsmass links:',
                front: 'Achsmass vorne:'
            },
            form: {
                title: 'Grundgrösse',
                tiefe: 'TIEFE',
                width: 'BREITE',
                to:    'bis',
                left:  'ACHSMASS LINKS',
                front: 'ACHSMASS VORNE'
            },

        },
        stepTwo: {
            menu: {
                title: 'Lochbohrungen',
                body:  {
                    len:                      '2',
                    1:                        'Armaturenloch, Seifenspender,',
                    2:                        'Kosmetiktuchspender, Steckdose',
                    MISSING_WT_ALAZ_CHECKBOX: 'Armaturenloch',
                    MISSING_WT_ALAZ_checkbox: 'Armaturenloch',
                    MISSING_WT_ALS_CHECKBOX:  'Sonderlochbohrung',
                    MISSING_WT_ALS_checkbox:  'Sonderlochbohrung',
                    MISSING_SSPV_checkbox:    'Seifenspender',
                    SSPV:                     'Seifenspender',
                    ST:                       'Steckdose',
                    HTH:                      'Handtuchhalter',
                },
            },
            form: {
                armaturenloch:            'mit Armaturenloch / Armaturenlöcher',
                armatur:                  'Armaturenloch',
                MISSING_WT_ALAZ_CHECKBOX: 'Armaturenloch',
                MISSING_WT_ALAZ_checkbox: 'Armaturenloch',
                MISSING_WT_ALS_CHECKBOX:  'Sonderlochbohrung',
                MISSING_WT_ALS_checkbox:  'Sonderlochbohrung',
                MISSING_SSPV_checkbox:    'Seifenspender',
                SSPV:                     'Seifenspender',
                ST:                       'Steckdose',
                HTH:                      'Handtuchhalter',
                position:                 'Position Armaturenloch',
                specialHole:              'Sonderlochbohrung',
                loch3:                    '3-Loch Armatur',
                description:              'Beschreibung',
                drawing:                  'ZEICHNUNG HOCHLADEN',
                soapDispenser:            'Lochbohrung für Seifenspender',
                socket:                   'Lochbohrung für Steckdose',
                towerHolder:              'Lochbohrung für Handtuchhalter',
                left:                     'links',
                S:                        'S',
                A:                        'A',
            },

        },
        stepThree: {
            menu: {
                title: 'Weitere Optionen',
                body:  {
                    len:  '2',
                    1:    'Kosmetiktuchspender',
                    2:    'ohne Überlauf',
                    UL:   'ohne Überlauf',
                    UL_inverter:   'ohne Überlauf',
                    KTSV: 'Kosmetiktuchspender',
                    MISSING_KTSV_checkbox: 'Kosmetiktuchspender',
                },
            },
            form: {
                tissueDispensers: 'Kosmetiktuchspender',
                UL:               'ohne Überlauf',
                KTSV:             'Kosmetiktuchspender',
                position:         'Position',
                withoutOverflow:  'ohne Überlauf',
                above_left:       'Hinten Links',
                above_right:      'Hinten Rechts',
                bellow_left:      'Vorne Links',
                bellow_right:     'Vorne Rechts',
                text_field: {
                    placeholder: 'Textfeld für Sonderwunsch',
                },
            },

        },
        stepFour: {
            menu: {
                title: 'Oberfläche',
                title2: 'Farbe',
                body:  {
                    len:       '2',
                    1:         'weiss matt',
                    2:         'Antigliss, Glasur Plus',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'ANTIGLISS PRO',
                    OV:        'GLASUR PLUS',
                },
            },
            form: {
                ober:           'OBERFLÄCHENVEREDELUNG',
                glazePlus:      'GLASUR PLUS',
                antiglissPro:   'ANTIGLISS PRO',
                txtPlaceholder: 'Textfeld für Sonderwunsch',
                colorName:      'Farbname',
                options:        [
                    'Farbname',
                ],
            },


        },
    },
    KRW: {
        stepOne: {
            menu: {
                title: 'Grösse',
                body:  {
                    len: '2',
                    1:   'Grundgrösse:',
                    2:   'Masse:',
                },
            },
            form: {
                title:  'Grösse',
                width:  'BREITE (MM)',
                length: 'LÄNGE (MM)',
                to:     'bis',
            },

        },
        stepTwo: {
            menu: {
                title: 'Sichtkanten',
                body:  {
                    len:   '2',
                    1:     'Sichtkante(n):',
                    back:  'oben',
                    front: 'unten',
                    left:  'links',
                    right: 'rechts',
                },
            },
            form: {
                title:    'Sichtkantencode:',
                checkbox: 'Teilzarge',
                left:     'Links',
                right:    'Rechts',
                back:     'Oben',
                front:    'Unten',
            },
            summary: {
                SK23: {
                    '1':  " · Sichtkante oben"
                },
                SK45: {
                    '1':  " · Sichtkante rechts"
                },
                SK67: {
                    '1':  " · Sichtkante unten"
                },
                SK81: {
                    '1':  " · Sichtkante links"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Steckdosen',
                title2: 'Steckdosen',
                type: 'Steckdosentyp',
                socket: 'Steckdose',
                body:  {
                    ST1: 'Steckdose 1',
                    ST2: 'Steckdose 2',
                    ST3: 'Steckdose 3',
                    ST4: 'Steckdose 4',
                    ST5: 'Steckdose 5',
                },
            },
            form: {
                type: 'Steckdosentyp',
                socket: 'Steckdose',
                position_x: 'Position horizontal (mm)',
                position_y: 'Position vertikal (mm)',
            },

        },
        stepFour: {
            menu: {
                title: 'Ausschnitte rechteckig',
                body:  {
                    AS1: '(1)',
                    AS2: '(2)',
                    AS3: '(3)',
                    AS4: '(4)',
                    AS5: '(5)',
                },
                summary:  {
                    AS1: 'Ausschnitt 1',
                    AS2: 'Ausschnitt 2',
                    AS3: 'Ausschnitt 3',
                    AS4: 'Ausschnitt 4',
                    AS5: 'Ausschnitt 5',
                },
            },
            form: {
                title: 'Ausschnitt',
                position_x: 'Position horizontal (mm)',
                position_y: 'Position vertikal (mm)',
                size_x: 'Mass horizontal (mm)',
                size_y: 'Mass vertikal (mm)',
            },

        },
        stepFive: {
            menu: {
                title: 'Ausschnitte rund',
                body:  {
                    ASR1: '(1)',
                    ASR2: '(2)',
                    ASR3: '(3)',
                    ASR4: '(4)',
                    ASR5: '(5)',
                },
                summary:  {
                    ASR1: 'Runder Ausschnitt 1',
                    ASR2: 'Runder Ausschnitt 2',
                    ASR3: 'Runder Ausschnitt 3',
                    ASR4: 'Runder Ausschnitt 4',
                    ASR5: 'Runder Ausschnitt 5',
                },
            },
            form: {
                title: 'Ausschnitt',
                measure: 'Durchmesser (mm)',
                position_x: 'Position horizontal (mm)',
                position_y: 'Position vertikal (mm)'
            },

        },
        stepSix: {
            menu: {
                title: 'Gebogene Kante',
                body:  {
                    GK45: 'Gebogene Kante rechts',
                    GK81: 'Gebogene Kante links',
                },
            },
            form: {
                measure: 'Mass in (mm)',
                left: 'Links',
                right: 'Rechts',
            },

        },
        stepSeven: {
            menu: {
                title: 'Oberfläche',
                title2: 'Farbe',
                body:  {
                    len:  '2',
                    OV:  'GLASUR PLUS',
                },
            },
            form: {
                ober:           'OBERFLÄCHENVEREDELUNG',
                glazePlus:      'GLASUR PLUS',
                antiglissPro:   'ANTIGLISS PRO',
                txtPlaceholder: 'Textfeld für Sonderwunsch',
                colorName:      'Farbname',
                options:        [
                    'Farbname',
                ],
            },

        },
    },
    previous:           'ZURÜCK',
    next:               'WEITER',
    downloadAndContact: {
        title:             'DOWNLOADS UND KONTAKT',
        configurationCode: 'Konfigurationscode:',
        schmidlinArtNo:    'Schmidln Art. Nr:',
        SGNr:              'SGVSB-Nr.:',
        stNr:              'ST-Nr:',
        recommended:       'Empfohlener',
        salesPrice:        'Brutto-Verkaufspreis',
        totalPrice:        'Endkosten',
        inquireQuotation:  'ZUSAMMENFASSUNG',
        order:             'BESTELLUNG AUFGEBEN',
        contactDealer:     'FACHHÄNDLER KONTAKTIEREN',
    },
    currencyCHF: 'CHF',
    BREADCRUMBS: {
        sortiment:   'SORTIMENT',
        model:       'MODELLBEZEICHNUNG',
        bathtub:     'BADEWANNEN',
        wt:          'WASCHTISCHE',
        dwdf:        'DUSCHWANNEN',
        krw:         'KÜCHENRÜCKWÄNDE',
        showerTrays: 'DUSCHWANNEN&FLACHEN',
        washbasins:  'WASCHTISCHE',
        urinals:     'URINALE',
    },
    showPrices: 'Preise anzeigen',
    hidePrices: 'Preise verbergen',
}



// WEBPACK FOOTER //
// ./src/translations/german.js